 import { styled } from "@mui/material/styles";


 const StyledOrderDetails = styled("div")(
  ({ theme }) => `
  .order-history-details-container-wrap {
    padding: 50px 20%;
    @media screen and (max-width: 1024px) {
      padding: 50px 8%;
    }

  }
  .order-history-details-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .order-history-details-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
  }
  .order-history-details-first-part {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;
  }  
  .order-date {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
    span {
      color: ${theme.palette.primary.main};
    }
  }
  .order-history-details-status {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 2px 10px;
    border-radius: 0px;
  }  
  .order-status-date {
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
  }
  .order-status-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
  }
  .order-history-details-second-part {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;
  } 
  .order-history-details-second-part-product {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .product-image {
    width: 74px;
    height: 84px;
    object-fit: cover;
  }
  .order-history-card-body-product-details {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .order-history-product-name {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .order-history-card-body-product-details-size {
    margin-top: 5px;
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .order-history-size {
    justify-content: center;
    align-items: center;
    width: fit-content;
    padding: 3px 10px;
    height: 20px;
    border-radius: 20px;
    background-color: #F0F0F0;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: #7D634F;
    display: flex;
  }
  .order-name {
    font-family: Belleza;
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .product-name {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
  }
  .order-history-details-second-part-price {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
  }
  .order-history-details-account-deatils {
    margin-top: 20px;
    background-color: #A78D781A;
    padding: 20px 15px;
  }
  .account-deatils-title {
    font-family: Lexend;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
    margin-bottom: 10px;
  }                     
  .account-deatils-subtotal {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
    display: flex;
    justify-content: space-between;
  }
  .account-deatils-subtitle {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
    margin-bottom: 10px;
  }
  .account-deatils-amount {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .account-deatils-total {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    align-items: center;
  }
  .account-deatils-total-subtitle {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .account-deatils-total-amount {
    font-family: Lexend;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .shipping-title {
    font-family: Lexend;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
    margin-bottom: 10px;
  }
  .shipping-details-box {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .shipping-details-text {
    font-family: Lexend;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .shipping-details-text-2 {
    margin-top: 5px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
  }
  .btns-wrap {
    width: 100%;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
  }  
  .continue-shopping-btn {
    width: 100%;
    border: 1px solid ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    text-transform: none;
    border-radius: 0px;
    background-color: ${theme.palette.customColor.white};
    padding: 10px 20px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    cursor: pointer;
  }
  .help-btn {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
  }                          
`)

 export default StyledOrderDetails